var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntegrateWithWorkspaceApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.882 19.941L24 25.882l-11.882-5.94L24 13.151l11.882 6.79z",
    stroke: "#4554FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.286L12 25l12 6 12-6-5-2.714",
    stroke: "#4554FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27l-5 3 12 6 12-6-5-3",
    stroke: "#4554FF",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFRkYwRkYiLz4KPHBhdGggZD0iTTM1Ljg4MTUgMTkuOTQxMkwyNCAyNS44ODJMMTIuMTE4NSAxOS45NDEyTDI0IDEzLjE1MThMMzUuODgxNSAxOS45NDEyWiIgc3Ryb2tlPSIjNDU1NEZGIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE3IDIyLjI4NjFMMTIgMjUuMDAwNEwyNCAzMS4wMDA0TDM2IDI1LjAwMDRMMzEgMjIuMjg2MSIgc3Ryb2tlPSIjNDU1NEZGIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE3IDI3TDEyIDMwTDI0IDM2TDM2IDMwTDMxIDI3IiBzdHJva2U9IiM0NTU0RkYiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgIntegrateWithWorkspaceApps as ReactComponent };